import * as React from 'react';
import { useGridRegisterPreProcessor } from '../../core/preProcessing';
export const useGridRegisterSortingMethod = (apiRef, groupingName, filteringMethod) => {
  const updateRegistration = React.useCallback(sortingMethodCollection => {
    sortingMethodCollection[groupingName] = filteringMethod;
    return sortingMethodCollection;
  }, [groupingName, filteringMethod]);
  useGridRegisterPreProcessor(apiRef, 'sortingMethod', updateRegistration);
};